export interface LegTableView {
  readonly instrument?: string;
  readonly instrument_name?: string;
  readonly instrumentLabel: string;
  readonly ratio: string;
  readonly side: 'BUY' | 'SELL';
  readonly index: number;
  readonly price: string;
  readonly rowNumber: number;
  readonly strike: string | number;
  readonly clearingUnitiesQuantity: string;
  readonly contractTermsQuantity: string;
  readonly quantity?: string;
  readonly contractCurrency: string;
  readonly productLabel: string;
  readonly productCurrency: string;
  readonly expiry: string;
}

/** Simplest representation of a quote */
export type SimpleQuote = readonly [
  qty: string,
  price: string,
  id?: number | string,
];

export interface MyQuoteItem {
  readonly id?: number | string;
  readonly key?: string;
  readonly price: string;
  readonly quantity: string;
  readonly iv?: string;
}

export interface TableQuoteItem {
  readonly id?: number | string;
  readonly key: string;
  readonly price: string;
  readonly quantity: string;
  readonly iv?: string;
}

export interface FormattingFn<T> {
  (raw: T): string;
}

export interface WithFormattingProps<T> {
  formattingFn: FormattingFn<T>;
  value: T;
  formatted: string;
}

export function createFormattingProps<T>(
  value: T,
  formattingFn: FormattingFn<T>,
): WithFormattingProps<T> {
  return {
    value,
    formattingFn,
    formatted: formattingFn(value),
  };
}
